import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  AboutMe as AboutMeView,
  Portfolio as PortfolioView,
  Resume as ResumeView,
  Publications as PublicationsView,
  QuickCodes as QuickCodesView,
  JavaScript as JavaScriptView,
  AngularJS as AngularJSView,
  Contact as ContactView,
  NotFound as NotFoundView,
  CheckersHaskell as CheckersHaskellView,
  Hotspot as HotspotView,
  MyWebsite as MyWebsiteView,
  RestApiV1 as RestApiV1View,
  RestApiV2 as RestApiV2View,
  Simulti as SimultiView,
  SnmpFiberhome as SnmpFiberhomeView,
  SpringBoot as SpringBootView,
  SwaggerAutogen as SwaggerAutogenView,
  Mista2015 as Mista2015View,
  HM2016 as HM2016View
} from './views';

const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/aboutme"
      />
      <RouteWithLayout
        component={AboutMeView}
        exact
        layout={MainLayout}
        path="/aboutme"
      />
      <RouteWithLayout
        component={PortfolioView}
        exact
        layout={MainLayout}
        path="/portfolio"
      />
      <RouteWithLayout
        component={ResumeView}
        exact
        layout={MainLayout}
        path="/resume"
      />
      <RouteWithLayout
        component={PublicationsView}
        exact
        layout={MainLayout}
        path="/publications"
      />
      <RouteWithLayout
        component={QuickCodesView}
        exact
        layout={MainLayout}
        path="/quickcodes"
      />
      <RouteWithLayout
        component={JavaScriptView}
        exact
        layout={MainLayout}
        path="/javascript"
      />
      <RouteWithLayout
        component={AngularJSView}
        exact
        layout={MainLayout}
        path="/angularjs"
      />
      <RouteWithLayout
        component={ContactView}
        exact
        layout={MainLayout}
        path="/contact"
      />
      <RouteWithLayout
        component={CheckersHaskellView}
        exact
        layout={MainLayout}
        path="/checkershaskell"
      />
      <RouteWithLayout
        component={HotspotView}
        exact
        layout={MainLayout}
        path="/hotspot"
      />
      <RouteWithLayout
        component={MyWebsiteView}
        exact
        layout={MainLayout}
        path="/mywebsite"
      />
      <RouteWithLayout
        component={RestApiV1View}
        exact
        layout={MainLayout}
        path="/restapiv1"
      />
      <RouteWithLayout
        component={RestApiV2View}
        exact
        layout={MainLayout}
        path="/restapiv2"
      />
      <RouteWithLayout
        component={SimultiView}
        exact
        layout={MainLayout}
        path="/simulti"
      />
      <RouteWithLayout
        component={SnmpFiberhomeView}
        exact
        layout={MainLayout}
        path="/snmpfiberhome"
      />
      <RouteWithLayout
        component={SpringBootView}
        exact
        layout={MainLayout}
        path="/springboot"
      />
      <RouteWithLayout
        component={SwaggerAutogenView}
        exact
        layout={MainLayout}
        path="/swaggerautogen"
      />
      <RouteWithLayout
        component={Mista2015View}
        exact
        layout={MainLayout}
        path="/mista2015"
      />
      <RouteWithLayout
        component={HM2016View}
        exact
        layout={MainLayout}
        path="/hm2016"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};


export default Routes;